import { z } from 'zod';
import { zLookup, zYesno } from '@/utils/zodHelper';
import { FailModeSchema } from './failmode';

export const ActionPlanSchema = z.object({
  theme: z.string().min(1, 'Campo obrigatório'),
  comment_general: z.string().min(1, 'Campo obrigatório'),
  status: zLookup().optional(),
  reference_number: z.string().optional(),
  finished_at: z.date().optional().nullable(),
  failure_mode: z.array(FailModeSchema).optional(),
  actions: z
    .array(
      z.object({
        id: z.number().optional().nullable(),
        description: z.string().optional(),
        status: zLookup().optional(),
        due_date: z.date().optional().nullable(),
        area: z.string().optional().nullable(),
        responsible: z.string().optional(),
        implemented: zYesno().optional(),
        displayed: z.boolean().optional().nullable(),
        file: z.string().optional().nullable(),
        functional_area: zLookup().optional().nullable(),
      }),
    )
    .optional(),
});

export type ActionPlanType = z.infer<typeof ActionPlanSchema>;
